import { Box, Typography } from '@mui/material';
import { useStyles } from '../styles';
import clsx from 'clsx';

export type LabelColonValueProps = {
  label: string;
  value: string;
  mb?: number;
  mt?: number;
  my?: number;
};

export const LabelColonValue: React.FC<LabelColonValueProps> = ({ label, value, mb = 1, mt = 1, my }) => {
  const { classes } = useStyles();

  const myProp = my !== undefined ? { my } : {};

  return (
    <Box mb={mb} mt={mt} {...myProp}>
      <Typography whiteSpace="pre-wrap">
        <Typography className={clsx([ classes.fontWeight500, classes.noWordBreak ])} component="span">{label}:&nbsp;</Typography>
        {value}
      </Typography>
    </Box>
  );
};

export const LabelColonValueSmall: React.FC<LabelColonValueProps> = ({ label, value, mb = 0.25, mt = 0.25, my }) => {
  const { classes } = useStyles();

  const myProp = my !== undefined ? { my } : {};

  return (
    <Box mb={mb} mt={mt} {...myProp}>
      <Typography variant="body2" className={classes.font14} color="textPrimary">
        {label}:&nbsp;{value}
      </Typography>
    </Box>
  );
};
